// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3UmSP","additionalInfo":"AgreementModal_additionalInfo__3lUrT"};